import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import SelectChip from '../../../form/component/SelectChip'
import currentUserHasAccess from '../../../../util/widget-helper'
import BeatLoader from "react-spinners/BeatLoader";
import { ATTACHMENT_NEEDED_WIDGET } from '../../ui-definition/process-ui'

const ATTACHMENT_VALUES = [
    {
        value: true,
        label: 'Attachment Needed',
    },
    {
        value: false,
        label: 'Attachment Not Needed',
    },
]

const WIDGET_TITLE = 'Attachment';

const AttachmentNeededWidget = ({
    readOnly,
    isAttachmentProviderStore,
    treatmentPlan,
    fetching,
    changeTreatmentPlan,
    saveTreatmentPlan,
}) => {

    if (!currentUserHasAccess(ATTACHMENT_NEEDED_WIDGET)) {
        return null
    }

    // force readOnly to be true if clinic do not offer attachment
    const internalReadOnly = isAttachmentProviderStore ? readOnly : true;

    const changeFormData = (name, value) => {
        changeTreatmentPlan(name, value);
        saveTreatmentPlan();
    }

    // prevent crash during data loading
    if (fetching && !internalReadOnly) {
        return <ContentBox title={WIDGET_TITLE}>
            <Row>
                <Column size={6}>
                    <p>Loading... Please wait.</p>
                    <BeatLoader loading={fetching}/>
                </Column>
            </Row>
        </ContentBox>
    }

    return (
        <ContentBox title={WIDGET_TITLE}>
            <Row>
                <Column size={6}>
                    {!isAttachmentProviderStore &&
                        <p><i>Clinic does not offer Attachment</i></p>
                    }
                    <LabelInput label="">
                        <SelectChip
                            object={treatmentPlan}
                            name="attachmentNeeded"
                            readOnly={internalReadOnly}
                            addEmpty={true}
                            valueList={ATTACHMENT_VALUES}
                            onChange={changeFormData}
                        />
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}

AttachmentNeededWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    treatmentPlan: PropTypes.object,
    changeTreatmentPlan: PropTypes.func.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    isAttachmentProviderStore: PropTypes.bool,
}

export default AttachmentNeededWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/AttachmentNeededWidget.js